export default "__VITE_ASSET__Ds69lTnQ__"